module.exports = __webpack_public_path__ + "img/challeng.1d29c366.png";